import { render, staticRenderFns } from "./SalesReportSales.vue?vue&type=template&id=e13746e4&scoped=true&"
import script from "./SalesReportSales.vue?vue&type=script&lang=ts&"
export * from "./SalesReportSales.vue?vue&type=script&lang=ts&"
import style0 from "./SalesReportSales.vue?vue&type=style&index=0&id=e13746e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13746e4",
  null
  
)

export default component.exports